import { Component, EventEmitter, Input, Output } from "@angular/core";

const MAX_PAGES = 5;
export type PaginationType = {
  totalPages: number;
  totalItems: number;
};

@Component({
  selector: "app-pagination",
  templateUrl: "pagination.component.html",
})
export class PaginationComponent {
  @Input() currentPage: number;
  @Input() totalPages: number;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  getPagesToShow(): number[] {
    const pagesToShow: number[] = [];

    if (this.totalPages <= MAX_PAGES) {
      for (let i = 0; i < this.totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      const halfMaxPages = Math.floor(MAX_PAGES / 2);
      let startPage = Math.max(0, this.currentPage - halfMaxPages);
      let endPage = Math.min(this.totalPages - 1, startPage + MAX_PAGES - 1);

      if (endPage - startPage + 1 < MAX_PAGES) {
        startPage = endPage - MAX_PAGES + 1;
      }

      if (startPage > 0) {
        pagesToShow.push(0);
        if (startPage > 1) {
          pagesToShow.push(-1); // for ellipsis
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pagesToShow.push(i);
      }

      if (endPage < this.totalPages - 1) {
        if (endPage < this.totalPages - 2) {
          pagesToShow.push(-1); // for ellipsis
        }
        pagesToShow.push(this.totalPages - 1);
      }
    }

    return pagesToShow;
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  goToPage(page: number) {
    if (page !== -1) {
      this.pageChange.emit(page);
    }
  }

  firstPage() {
    this.pageChange.emit(0);
  }
  lastPage() {
    this.pageChange.emit(this.totalPages - 1);
  }

  get nextDisabled() {
    return this.currentPage === this.totalPages - 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/pagination/pagination.component.ts